import { toast } from 'src/design-system';

const DEFAULT_TOAST_TIMEOUT = 5000;

interface ToastProps {
  title?: string;
  description?: string;
  timeout?: number;
}

const getMessage = (toastProps: ToastProps) => toastProps.title ?? toastProps.description ?? '';

export const successToast = (toastProps: ToastProps) => {
  toast(getMessage(toastProps), {
    description: toastProps.description,
    timeout: toastProps.timeout ?? DEFAULT_TOAST_TIMEOUT,
    variant: 'success'
  });
};

export const errorToast = (toastProps: ToastProps) => {
  toast(getMessage(toastProps), {
    description: toastProps.description,
    timeout: toastProps.timeout ?? DEFAULT_TOAST_TIMEOUT,
    variant: 'danger'
  });
};

export const infoToast = (toastProps: ToastProps) => {
  toast(getMessage(toastProps), {
    description: toastProps.description,
    timeout: toastProps.timeout ?? DEFAULT_TOAST_TIMEOUT,
    variant: 'default'
  });
};
